import { h } from 'preact';

export const ReviewedIcon = (): h.JSX.Element => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      clip-rule="evenodd"
      d="M5.56893 15L8 14.4092L10.4311 15L11.9194 12.9607L14.1557 11.8265L14.0049 9.2928L15 6.96431L13.2806 5.12185L12.5689 2.68861L10.0855 2.39945L8 1L5.91453 2.39945L3.43107 2.68861L2.71939 5.12185L1 6.96431L1.99512 9.2928L1.8443 11.8265L4.08059 12.9607L5.56893 15ZM11.6074 5.24289C11.2776 4.96378 10.7874 5.00903 10.5125 5.34397L7.1697 9.4152L6.21742 8.44886L6.14418 8.38319C5.8392 8.14239 5.39821 8.16428 5.11796 8.44886C4.81435 8.75715 4.81435 9.25699 5.11796 9.56528L6.67283 11.1441L6.74512 11.2091C7.07074 11.4672 7.54805 11.4224 7.81981 11.0913L11.707 6.35473L11.7648 6.27472C11.9733 5.94451 11.9119 5.50054 11.6074 5.24289Z"
      fill="#31B551"
      fill-rule="evenodd"
    />
  </svg>
);
